import { FC } from "react";
import { Mode, QuestionField, Type } from "../Form";
import { BaseElement } from "../BaseElement";
import HTMLParser from "../../HTMLParser/HTMLParser";

type Options = {headline?: string, text?: string, renderId?: string};

export class Paragraph extends BaseElement {
  text: string;

  constructor(options?: Options) {
    const { text, renderId } = options ?? {};
    super(Type.ParagraphElement, renderId);
    this.text = text ?? '';
  }

  render(mode: Mode, onElementChange: (element: Paragraph) => void): JSX.Element {
    return <ParagraphElement key={this.renderId} mode={mode} element={this} onElementChange={onElementChange} />
  }

  getForDB() {
    return {
      type: this.type,
      renderId: this.renderId,
      text: this.text,
    }
  }
}

type Props = {
  element: Paragraph,
  mode: Mode;
  onElementChange: (element: Paragraph) => void
}

export const ParagraphElement: FC<Props> = ({ element, mode, onElementChange }) => {
  const { text } = element;

  const onChangeText = (value: string) => {
    element.text = value;
    onElementChange(element);
  }
  if (mode === Mode.FORM || mode === Mode.READ_ONLY) {
    return (
      <div style={{ marginBottom: '16px', color: 'var(--gray-700)' }}>
        <HTMLParser data={text} />
      </div>
    )
  } else if (mode === Mode.EDIT) {
    return (
      <QuestionField
        value={text}
        label={'Text'}
        onChange={onChangeText}
      />
    )
  }
}